import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User created or reactivated a CDN link for an asset',
  name: 'created_cdn_link',
  params: [
    {
      description: 'The Air asset ID',
      name: 'asset_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Whether this was a new creation or reactivation of an existing link',
      name: 'action',
      required: true,
      type: 'enum',
      values: ['create', 'reactivate'],
    },
  ],
};

export default META;
